import { render, staticRenderFns } from "./EcommerceOrderClient.vue?vue&type=template&id=cb1633a0&"
import script from "./EcommerceOrderClient.vue?vue&type=script&lang=js&"
export * from "./EcommerceOrderClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports